import { all, takeEvery } from 'redux-saga/effects';

import {
  LOGIN,
  GET_IS_AUTH,
  SET_CULTURES,
  GET_GS_MODULE_ACTIVE,
  GET_USER_PROFILE,
  USER_ENTITIES_SAVE,
  USER_DATE,
  USER_MODULES_SAVE,
  USER_MODULES,
  SHOW_ENTITIES,
  LOGOUT,
  SESSION_TIMEOUT,

  MFA_VERIFY,
} from '../types/actionTypes';

import { culture, gsModuleActive, showEntities } from './settingsSaga';

import {
  profile,
  entitiesSave,
  dateSave,
  modulesSave,
  modules,
} from './userSaga';

import { login, getIsAuth, logout, verifyMfa  } from './authSaga';

export default function* rootSaga() {
  // console.log('ROOT SAGA');
  yield all([
    takeEvery(LOGIN, login),
    takeEvery(MFA_VERIFY, verifyMfa),
    takeEvery(GET_IS_AUTH, getIsAuth),
    takeEvery(SET_CULTURES, culture),
    takeEvery(GET_USER_PROFILE, profile),
    takeEvery(USER_ENTITIES_SAVE, entitiesSave),
    takeEvery(USER_DATE, dateSave),
    takeEvery(USER_MODULES_SAVE, modulesSave),
    takeEvery(USER_MODULES, modules),
    takeEvery(SHOW_ENTITIES, showEntities),
    takeEvery(LOGOUT, logout),
    takeEvery(GET_GS_MODULE_ACTIVE, gsModuleActive),
    //takeEvery(SESSION_TIMEOUT, sessionTimeout),
  ]);
}
